import { useNavigate } from 'react-router-dom';
import AdsApi, { EXPORTS } from '../api/ads';
import { AdAccountFilter, DEFAULT_SITE, SiteFilter, StatusFilter, listUrl } from '../components/ads/AdFilters';
import { Budget, METRIC_COLUMNS, NameCell, StatusChip } from '../components/ads/cells';
import ListPage from '../components/table/ListPage';
import { formatNumber, humanize } from '../utils/format';

const DEFAULTS = { site: DEFAULT_SITE, ordering: '-spend' };

const COLUMNS = [
  { id: 'name', label: 'Campaign', render: (row) => <NameCell name={row.name} secondary={row.ad_account_name} /> },
  { id: 'effective_status', label: 'Status', render: (row) => <StatusChip row={row} /> },
  { id: 'objective', label: 'Objective', render: (row) => humanize(row.objective) },
  { id: 'budget', label: 'Budget', sort: 'daily_budget', render: (row) => <Budget row={row} /> },
  { id: 'adset_count', label: 'Ad sets', align: 'right', sort: false, render: (row) => formatNumber(row.adset_count) },
  { id: 'ad_count', label: 'Ads', align: 'right', sort: false, render: (row) => formatNumber(row.ad_count) },
  ...METRIC_COLUMNS,
];

export default function Campaigns() {
  const navigate = useNavigate();
  return (
    <ListPage
      exportPath={EXPORTS.campaigns}
      title="Campaigns" description="Campaigns of your synced ad accounts. Open one to see its ad sets."
      fetchList={AdsApi.campaigns} defaults={DEFAULTS} columns={COLUMNS} minWidth={1150}
      onRowClick={(row, query) => navigate(listUrl('/adsets', query, { ad_account: row.ad_account_id,
        campaign: row.id }))}
      emptyTitle="No campaigns yet" emptyHint="Enable an ad account and run a sync to see its campaigns."
      searchPlaceholder="Search name or id"
      filters={({ query, setQuery }) => (
        <>
          <SiteFilter query={query} setQuery={setQuery} />
          <StatusFilter query={query} setQuery={setQuery} />
          <AdAccountFilter query={query} setQuery={setQuery} />
        </>
      )}
    />
  );
}
